import React, { PropsWithChildren } from 'react'
import { toast } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useDeleteTimeClockMutation } from 'queries/admin/timeClock'
import { useTimeClocksWorkflowsContextValue } from '../../../context/TimeClocksWorkflowsProvider'

type DeleteTimeClockFlowContextState = {
  state: {
    isPending: boolean
    isError: boolean
    errorMessage: string | undefined
  }
  actions: {
    confirm: () => void
    reset: ReturnType<typeof useDeleteTimeClockMutation>['reset']
  }
}

const [Context, useDeleteTimeClockFlowContextValue] =
  createContext<DeleteTimeClockFlowContextState>({
    name: 'DeleteTimeClockFlowContext',
  })

export const DeleteTimeClockFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { deleteTimeClockFlow } = useTimeClocksWorkflowsContextValue()
  const { mutate, reset, isPending, isError, error } =
    useDeleteTimeClockMutation()

  const value: DeleteTimeClockFlowContextState = {
    state: {
      isPending,
      isError,
      errorMessage: parseErrorMessage(error),
    },
    actions: {
      confirm: () => {
        const { timeClock, close } = deleteTimeClockFlow
        if (!timeClock) return
        mutate(
          { timeClockId: timeClock.id },
          {
            onSuccess: () => {
              toast.success('Clock deregistered', {
                position: 'top-center',
              })
              close()
            },
          }
        )
      },
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDeleteTimeClockFlowContextValue }
